__turbopack_context__.v({
  "cards": "OutfittingTile-module-scss-module__dmwHxW__cards",
  "copy": "OutfittingTile-module-scss-module__dmwHxW__copy",
  "cta": "OutfittingTile-module-scss-module__dmwHxW__cta",
  "heading": "OutfittingTile-module-scss-module__dmwHxW__heading",
  "image": "OutfittingTile-module-scss-module__dmwHxW__image",
  "imageWrapper": "OutfittingTile-module-scss-module__dmwHxW__imageWrapper",
  "info": "OutfittingTile-module-scss-module__dmwHxW__info",
  "media": "OutfittingTile-module-scss-module__dmwHxW__media",
  "overlay": "OutfittingTile-module-scss-module__dmwHxW__overlay",
  "root": "OutfittingTile-module-scss-module__dmwHxW__root",
  "skeletonCard": "OutfittingTile-module-scss-module__dmwHxW__skeletonCard",
  "skeletonHeading": "OutfittingTile-module-scss-module__dmwHxW__skeletonHeading",
  "skeletonImage": "OutfittingTile-module-scss-module__dmwHxW__skeletonImage",
  "skeletonLines": "OutfittingTile-module-scss-module__dmwHxW__skeletonLines",
  "skeletonRow": "OutfittingTile-module-scss-module__dmwHxW__skeletonRow",
  "skeletonThumb": "OutfittingTile-module-scss-module__dmwHxW__skeletonThumb",
  "tile": "OutfittingTile-module-scss-module__dmwHxW__tile",
  "visuallyHidden": "OutfittingTile-module-scss-module__dmwHxW__visuallyHidden",
});
